<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('tailoring orders')"
      :columns="columns"
      :column_search="true"
      :page_length="100"
      resource_url="/tailoring_order/datatables"
      :is_container="false"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/tailoring_order/settings' })"
        >
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("ordering links") }}</span>
        </button>
        <!-- <button
          class="button is-secondary is-rounded"
          @click="mode = 'add_many'"
        >
          <span class="icon"><i class="fa fa-cubes"></i></span>
          <span>{{ $t("add orders to work order") }}</span>
        </button> -->
        <!-- <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/tailoring_order/own' })"
        >
          <span class="icon"><i class="fa fa-cubes"></i></span>
          <span>{{ $t("our orders") }}</span>
        </button> -->
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <order-modal ref="order_modal" />
    <assign-order-modal ref="assign_order_modal" @success="refresh" />
    <billing-modal ref="billing_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import OrderModal from "../order_modal/Index.vue";
import AssignOrderModal from "../assign_order_modal/Index.vue";
import BillingModal from "../billing_modal/Index.vue";

export default {
  name: "OrdersDatatable",
  components: { GenericTable, OrderModal, AssignOrderModal, BillingModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.create_date);
          },
        },
        // {
        //   title: v.$t("source"),
        //   searchable: false,
        //   // width: "20%",
        //   data: (row) => {
        //     return row.source || "";
        //   },
        // },
        {
          title: v.$t("number"),
          name: "order_number",
          searchable: true,
          // width: "20%",
          data: (row) => {
            return row.order_number || "";
          },
        },
        {
          title: v.$t("name"),
          searchable: false,
          width: "25%",
          data: (row) => {
            return `${row.name} ${row.email} ${row.phone} ${row.grade}`;
          },
        },
        {
          title: v.$t("total"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total || 0);
          },
        },
        {
          title: v.$t("paid"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total_paid || 0);
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.translate_status(row.status_code || "");
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/tailoring_order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            if (row.settings && row.settings.billing_nit)
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("billing required"),
                icon: "fa fa-file-text",
                icon_class: "is-small has-text-warning",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.billing_modal.show_modal(row);
                },
              });

            if (row.work_order_item)
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: `${v.$t("assigned to work order")}, ${v.$t(
                  "status"
                )}: ${row.work_order_item.order.status_code}`,
                icon: "fa fa-cogs",
                icon_class: "is-small has-text-success",
                click: function (e) {
                  // console.log("work order", row.work_order_items);
                  v.$refs.assign_order_modal.edit_modal(row);
                },
              });
            else
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("add to work order"),
                icon: "fa fa-cogs",
                icon_class: "is-small has-text-warning",
                click: function (e) {
                  // console.log("work order", row.work_order_items);
                  v.$refs.assign_order_modal.show_modal(row);
                },
              });

            if (row.is_validated) {
              if (row.validation_result) {
                if (row.validation_result.result == "approved")
                  btns.unshift({
                    args: { uuid: row.uuid },
                    tooltip: v.$t("validated"),
                    icon: "fa fa-check",
                    icon_class: "is-small has-text-info",
                    click: function (e) {},
                  });
                else if (row.validation_result.result == "rejected")
                  btns.unshift({
                    args: { uuid: row.uuid },
                    tooltip: `${v.$t("rejected")}: ${
                      row.validation_result.reason
                    }`,
                    icon: "fa fa-times",
                    icon_class: "is-small has-text-danger",
                    click: function (e) {
                      // console.log("work order", row.work_order_items);
                    },
                  });
                else
                  btns.unshift({
                    args: { uuid: row.uuid },
                    tooltip: v.$t("unknown result"),
                    icon: "fa fa-question",
                    icon_class: "is-small has-text-warning",
                    click: function (e) {
                      // console.log("work order", row.work_order_items);
                    },
                  });
              } else {
                btns.unshift({
                  args: { uuid: row.uuid },
                  tooltip: v.$t("validation failed"),
                  icon: "fa fa-question",
                  icon_class: "is-small has-text-danger",
                  click: function (e) {
                    // console.log("work order", row.work_order_items);
                  },
                });
              }
            } else
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("waiting for validation"),
                icon: "fa fa-clock-o",
                icon_class: "is-small has-text-warning",
                click: function (e) {
                  // console.log("work order", row.work_order_items);
                },
              });

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.order_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "N":
          return v.$t("new");
        default:
          return status_code;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
